"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mapello": {
    "14a5751c": [{
      "hkey": "806509c1",
      "slug": "mapello",
      "name": "Mapello",
      "primary": true,
      "skipSearch": false
    }],
    "baracche": [{
      "hkey": "806509c1",
      "slug": "mapello",
      "name": "Mapello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cae600c6": [{
      "hkey": "806509c1",
      "slug": "mapello",
      "name": "Mapello",
      "primary": true,
      "skipSearch": false
    }],
    "cabergnino": [{
      "hkey": "806509c1",
      "slug": "mapello",
      "name": "Mapello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62856068": [{
      "hkey": "f34c76b9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mapello": [{
      "hkey": "f34c76b9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;